import './Faqs.css'
import React, { Component } from 'react'

import Content from './Content'

class Faqs extends Component {
    state = {}
    
    render() {
        const { title, faq } = this.props

        return <section className='faqs'>
            <div className='container'>
                {title && <h2>{title}</h2>}
                {faq.map(({ question, answer }, index) =>
                    <div className={`faq ${this.state[`activeFaq${index}]`] ? 'active' : ''}`} key={index}>
                        <p className='faq-question' onClick={() => this.setState({ [`activeFaq${index}]`]: !this.state[`activeFaq${index}]`] })}>{question}</p>
                        {answer && <Content src={answer} />}
                    </div>
                )}
            </div>
        </section>
    }
}
    
export default Faqs


// WEBPACK FOOTER //
// ./src/components/Faqs.js